(function () {

    'use strict';
    angular.module('iplusjs.utils.removeWhitespace', [
        'iplusjs.utils.format'
    ])
    .directive('iplusjsRemoveWhitespaces', removeWhitespaces);

    removeWhitespaces.$inject = [
        'FormatUtilsService'
    ];
    function removeWhitespaces(FormatUtilsService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            priority: 1000,
            link: function ($scope, $element, $attr, $ngModel) {
                function toModel(value) {
                    var modelValue = FormatUtilsService.removeWhitespaces(value);

                    if (modelValue !== value) {
                        $ngModel.$setViewValue(modelValue);
                        $ngModel.$render();
                    }

                    return modelValue;
                }

                $ngModel.$parsers.push(toModel);
            }
        };
    }
})();
